import {Component, OnInit} from '@angular/core'
import {Router} from '@angular/router'
import {AuthService} from '../auth.service'

@Component({
  selector: 'logout',
  template: ''
})
export class LogoutComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) {}

  async ngOnInit() {
    await this.authService.logout()
    return this.router.navigate(['/auth'], {replaceUrl: true})
  }
}
